<script>
export default {
  props: {
    professional: {
      type: Object
    }
  },
  data() {
    return {
      preview_image: "",
      file: null
    };
  },
  methods: {
    changeFile(e) {
      const file = e.target.files[0];

      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.preview_image = URL.createObjectURL(file);
        this.file = file;

        let data = new FormData();
        data.append("upload_preset", "professionals");
        data.append("file", file);
        data.append("profile_id", this.professional.account.profile.id);

        this.$emit("update", data);
      }
    }
  },
  mounted() {
    this.preview_image = this.professional.account.profile.profile_picture;
  }
};
</script>

<template>
  <div>
    <input type="file" class="hidden" id="photo" @change="changeFile" accept=".jpg, .jpeg, .png">

    <label class="photo" for="photo">
      <img :src="preview_image" width="100%">
      <div class="overlay"></div>
    </label>
  </div>
</template>

<style scoped>
.hidden {
  display: none;
}

.photo {
  width: 150px;
  height: 150px;
  border-radius: 100%;
  background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.8) 0,
      rgba(255, 255, 255, 0.8) 100%
    ),
    url("/static/user-solid.png") no-repeat center bottom #fff;
  background-size: 120px 120px;
  text-align: center;
  line-height: 200px;
  box-shadow: 0 0 0 6px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.photo img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: cover;
  object-position: center;
  transition: all 0.25s ease;
}

.photo [src="#"] {
  opacity: 0;
}

.photo .overlay {
  background: url("/static/edit-photo.svg") center no-repeat;
  background-color: rgba(255, 255, 255, 0.8);
  background-size: 70px;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  margin-top: -150px;
  opacity: 0;
  cursor: pointer;
  transition: all 0.25s ease;
}

.photo:hover .overlay {
  opacity: 1;
}

/* .upload-photo {
  margin: 0 20px 0 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--purple);
  opacity: 0.6;
  transition: all 0.24s ease;
  cursor: pointer;
  padding: 60px 0;
}

.upload-photo:hover {
  opacity: 1;
}

.upload-photo img {
  width: 50px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .upload-photo {
    margin: 0;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Photo.vue